export const NEW_CLIENT = 'REGISTER/NEW_CLIENT'